import { ChevronRight } from "lucide-react";
import { Fragment } from "react";
import { Link } from "react-router-dom";

export type BreadcrumbItem = {
  readonly label: string;
  readonly to?: string;
};

type BreadcrumbProps = {
  readonly items: readonly BreadcrumbItem[];
  readonly className?: string;
};

export const Breadcrumb = ({ items, className }: BreadcrumbProps) => {
  if (!items.length) {
    return null;
  }

  const wrapperClassName = className ? `mb-4 ${className}` : "mb-4";

  return (
    <nav aria-label="Breadcrumb" className={wrapperClassName}>
      <ol className="flex flex-wrap items-center gap-1.5 text-sm leading-5">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          const canNavigate = Boolean(item.to) && !isLast;

          return (
            <Fragment key={`${item.label}-${index}`}>
              <li>
                {canNavigate ? (
                  <Link
                    to={item.to!}
                    className="rounded-sm px-0.5 text-gray-600 decoration-gray-400 underline-offset-4 transition-colors hover:text-primary-600 hover:decoration-primary-500"
                  >
                    {item.label}
                  </Link>
                ) : (
                  <span
                    aria-current={isLast ? "page" : undefined}
                    className="rounded-sm px-0.5 font-medium text-gray-900 decoration-gray-400 underline-offset-4"
                  >
                    {item.label}
                  </span>
                )}
              </li>
              {!isLast && (
                <li aria-hidden="true">
                  <ChevronRight className="h-3.5 w-3.5 text-gray-300" />
                </li>
              )}
            </Fragment>
          );
        })}
      </ol>
    </nav>
  );
};
